export default __webpack_public_path__ + "7edb8eb.mp3";